/* @flow */
import { handleActions } from 'redux-actions';

import { PROJECT_ACTION_TYPES } from './constants';
import ProjectsState from './ProjectsState';

import type { Action } from '../types';
import type {
  ReceiveProjectPayload,
  ReceiveProjectsPayload,
  ReceiveActiveProjectPayload
} from './types';

const initialState = new ProjectsState();

const actions = {
  [PROJECT_ACTION_TYPES.CREATE_PROJECT]: createProject,
  [PROJECT_ACTION_TYPES.FETCH_PROJECTS]: fetchProjects,
  [PROJECT_ACTION_TYPES.RECEIVE_PROJECT]: receiveProject,
  [PROJECT_ACTION_TYPES.RECEIVE_PROJECTS]: receiveProjects,
  [PROJECT_ACTION_TYPES.RECEIVE_ACTIVE_PROJECT]: receiveActiveProject
};

// eslint-disable-next-line object-curly-spacing
function receiveActiveProject(state: ProjectsState, { payload }: Action<ReceiveActiveProjectPayload>): ProjectsState {
  if (!payload) {
    return state;
  }
  return state.setActiveProject(payload.project);
}

function fetchProjects(state: ProjectsState): ProjectsState {
  return state.setIsFetchingProjects(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveProjects(state: ProjectsState, { payload }: Action<ReceiveProjectsPayload>): ProjectsState {
  if (!payload) {
    return state;
  }
  return state
    .setIsFetchingProjects(false)
    .setProjects(payload.projects);
}

function createProject(state: ProjectsState): ProjectsState {
  return state.setIsCreatingProject(true);
}

function editProject(state: ProjectsState): ProjectsState {
  return state.setIsEditingProject(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveProject(state: ProjectsState, { payload }: Action<ReceiveProjectPayload>): ProjectsState {
  if (!payload) {
    return state;
  }
  return state
    .setIsFetchingProjects(false)
    .setIsCreatingProject(false)
    .addOrReplaceProject(payload.project);
}

function receiveDeletedProject(state: ProjectsState, { payload }: Action<ReceiveProjectPayload>): ProjectsState {
  if (!payload) {
    return state;
  }
  return state.removeProject(payload.project);
}

export default handleActions(actions, initialState);



// WEBPACK FOOTER //
// ./src/redux/projects/reducer.js